import { useMemo, type CSSProperties } from "react";
import type { BboxRipplePathsProps } from "./types";

export const BboxRipplePaths = ({
  ripplePaths,
  zoomLevel,
}: BboxRipplePathsProps) => {
  const rippleScale = useMemo(() => Math.max(zoomLevel ** 1.6, 1), [zoomLevel]);

  return (
    <g
      style={
        {
          "--ripple-w-start": `${rippleScale}px`,
          "--ripple-w-peak": `${rippleScale * 18}px`,
          "--ripple-w-end": `${rippleScale * 25}px`,
        } as CSSProperties
      }
    >
      {ripplePaths.map((batch) => (
        <path
          key={`${batch.color}-ripple`}
          d={batch.pathData}
          fill="none"
          stroke={batch.color}
          vectorEffect="non-scaling-stroke"
          className="bbox-ripple-path"
        />
      ))}
    </g>
  );
};
